import nrInstance from '@arcotech-services/newrelic-frontend-agents/pro_spa'
import {
  BrowserConfig,
  BrowserConfiguration
} from '@arcotech-services/newrelic-frontend'

const config: BrowserConfiguration = {
  appName: 'hub-digital-front-prd',
  accountID: '3141492',
  agentID: '1134318366',
  licenseKey: 'NRJS-20b97052e708fa14884',
  applicationID: '1134318366'
}

// eslint-disable-next-line prefer-const
let newrelic = new BrowserConfig(config)

function init(): void {
  newrelic.init(nrInstance)
}

export { init, newrelic }
